export default __webpack_public_path__ + "static/media/bestHotel-removebg-preview.610f52b1.png";